export class SessionStorageUtil {
  private static toJSON(value: any) {
    try { return JSON.stringify(value); } catch { return ""; }
  }
  private static fromJSON<T>(raw: string | null): T | null {
    if (!raw) return null;
    try { return JSON.parse(raw) as T; } catch { return null; }
  }

  static set(key: string, value: any): void {
    sessionStorage.setItem(key, this.toJSON(value));
  }
  static get<T>(key: string): T | null {
    return this.fromJSON<T>(sessionStorage.getItem(key));
  }
  static remove(key: string): void {
    sessionStorage.removeItem(key);
  }

  /** Optional helpers (handy across modules) */
  static getOrDefault<T>(key: string, fallback: T): T {
    const v = this.get<T>(key);
    return v == null ? fallback : v;
  }
  static clearByPrefix(prefix: string): void {
    const rm: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const k = sessionStorage.key(i);
      if (k && k.startsWith(prefix)) rm.push(k);
    }
    rm.forEach(k => sessionStorage.removeItem(k));
  }
}
